import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#0B0E14] text-white flex items-center justify-center px-5">
      <div className="absolute inset-0 dot-grid opacity-30" />
      <div className="relative glass rounded-3xl p-10 max-w-md w-full text-center" data-testid="payment-cancel-card">
        <div className="h-20 w-20 rounded-full bg-amber-500/15 flex items-center justify-center mx-auto"><XCircle size={44} className="text-amber-400" /></div>
        <h1 className="font-display text-2xl font-bold mt-6">{t("payment.cancelTitle")}</h1>
        <p className="text-slate-400 mt-2 text-sm">{t("payment.cancelDesc")}</p>
        <button onClick={() => navigate("/")} className="mt-8 w-full adj-gradient text-white font-semibold py-3.5 rounded-full hover:opacity-90 transition-opacity" data-testid="cancel-home-btn">
          {t("payment.home")}
        </button>
      </div>
    </div>
  );
}
